import { type TokenGroup } from "../../types";
import { altitude } from "../globals/altitude";
import { amber } from "../globals/amber";
import { cyan } from "../globals/cyan";
import { flash } from "../globals/flash";
import { grass } from "../globals/grass";
import { gray } from "../globals/gray";

export const border = {
  name: "border",
  variables: {
    default: {
      type: "color",
      value: {
        dark: gray.variables["4"].value.dark,
        light: gray.variables["4"].value.light,
      },
    },
    error: {
      type: "color",
      value: {
        dark: flash.variables["9"].value.dark,
        light: flash.variables["9"].value.light,
      },
    },
    "error-subtle": {
      type: "color",
      value: {
        dark: flash.variables["6"].value.dark,
        light: flash.variables["6"].value.light,
      },
    },
    "hover-input": {
      type: "color",
      value: {
        dark: gray.variables["7"].value.dark,
        light: gray.variables["7"].value.light,
      },
    },
    "hover-input-error": {
      type: "color",
      value: {
        dark: flash.variables["10"].value.dark,
        light: flash.variables["10"].value.light,
      },
    },
    input: {
      type: "color",
      value: {
        dark: gray.variables["5"].value.dark,
        light: gray.variables["5"].value.light,
      },
    },
    primary: {
      type: "color",
      value: {
        dark: altitude.variables["9"].value.dark,
        light: altitude.variables["9"].value.light,
      },
    },
    promotional: {
      type: "color",
      value: {
        dark: cyan.variables["6"].value.dark,
        light: cyan.variables["6"].value.light,
      },
    },
    strong: {
      type: "color",
      value: {
        dark: gray.variables["6"].value.dark,
        light: gray.variables["6"].value.light,
      },
    },
    subtle: {
      type: "color",
      value: {
        dark: gray.variables["3"].value.dark,
        light: gray.variables["3"].value.light,
      },
    },
    success: {
      type: "color",
      value: {
        dark: grass.variables["6"].value.dark,
        light: grass.variables["6"].value.light,
      },
    },
    warning: {
      type: "color",
      value: {
        dark: amber.variables["6"].value.dark,
        light: amber.variables["6"].value.light,
      },
    },
  },
} as const satisfies TokenGroup<"border">;
